module.exports = __webpack_public_path__ + "img/icon-bulb.601e3d97.png";